var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-navigation" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized"
            }
          ],
          staticClass: "mobile-navigation__inner"
        },
        [
          _c(
            "div",
            { attrs: { id: "accordion" } },
            [
              _c("div", { staticClass: "card card--main" }, [
                _c(
                  "div",
                  {
                    staticClass: "navigation-accordion__headline",
                    class: { active: _vm.isHome }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "navigation-accordion__headline",
                        attrs: { href: "/" }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$translate(
                                "FLGNTLT::Template.HompageCategoryName"
                              )
                            ) +
                            "\n                        "
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.navigationTree, function(category, key) {
                return [
                  _c("div", { staticClass: "card", class: "card--" + key }, [
                    category.details.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "navigation-accordion__headline",
                            class: {
                              active: _vm.openCategories.includes(category.id)
                            },
                            attrs: { id: "heading" + key }
                          },
                          [
                            category.childCount > 0
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "navigation-accordion__headline",
                                    attrs: {
                                      "data-toggle": "collapse",
                                      href: "#collapse" + key,
                                      role: "button",
                                      "aria-expanded": "true",
                                      "aria-controls": "collapse" + key
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(category.details[0].name) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              : category.details.length > 0
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "navigation-accordion__headline",
                                    attrs: {
                                      href: _vm.getCategoryUrl(
                                        category.details[0]
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(category.details[0].name) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    category.childCount > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "collapse",
                            attrs: {
                              id: "collapse" + key,
                              "aria-labelledby": "heading" + key,
                              "data-parent": "#accordion"
                            }
                          },
                          [
                            _c(
                              "ul",
                              { staticClass: "navigation-accordion__ul" },
                              [
                                _vm.hasAll.includes(category.id + "") &&
                                category.details.length > 0
                                  ? _c(
                                      "li",
                                      {
                                        staticClass: "navigation-accordion__li",
                                        class: {
                                          active:
                                            _vm.openCategories.includes(
                                              category.id
                                            ) && _vm.openCategories.length === 1
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getCategoryUrl(
                                                category.details[0]
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "FLGNTLT::Template.all"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasArchive.includes(category.id + "")
                                  ? [
                                      _vm._l(
                                        _vm.reverseArray(category.children),
                                        function(subCat, key2) {
                                          return [
                                            key2 < 5 &&
                                            subCat.details.length > 0 &&
                                            category.details.length > 0
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "navigation-accordion__li",
                                                    class: {
                                                      active: _vm.openCategories.includes(
                                                        subCat.id
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.getCategoryUrl(
                                                            category.details[0],
                                                            subCat.details[0]
                                                          )
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            subCat.details[0]
                                                              .name
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      )
                                    ]
                                  : [
                                      _vm._l(category.children, function(
                                        subCat
                                      ) {
                                        return [
                                          subCat.details.length > 0 &&
                                          category.details.length > 0
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "navigation-accordion__li",
                                                  class: {
                                                    active: _vm.openCategories.includes(
                                                      subCat.id
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: _vm.getCategoryUrl(
                                                          category.details[0],
                                                          subCat.details[0]
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          subCat.details[0].name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                _vm._v(" "),
                                _vm.hasArchive.includes(category.id + "") &&
                                category.details.length > 0
                                  ? _c(
                                      "li",
                                      {
                                        staticClass: "navigation-accordion__li",
                                        class: {
                                          active:
                                            _vm.openCategories.includes(
                                              category.id
                                            ) && _vm.openCategories.length === 1
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getCategoryUrl(
                                                category.details[0]
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "FLGNTLT::Template.archive"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _vm._t("languageselect"),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                on: {
                  click: function($event) {
                    return _vm.closeNavigation()
                  }
                }
              }),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c("loading-animation")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }